import template from './general-business.html';
import controller from './general-business.controller';

let generalBusinessComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default generalBusinessComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/general-business/general-business.component.js